export function getVendorBrandOptions(products) {
  const brandsByKey = new Map();
  for (const product of products) {
    const brand = typeof product.brand === 'string' ? product.brand.trim() : '';
    if (!brand) continue;

    const key = brand.replace(/\s+/g, ' ').toLocaleLowerCase();
    if (!brandsByKey.has(key)) brandsByKey.set(key, brand);
  }

  return [...brandsByKey.values()].sort((first, second) =>
    first.localeCompare(second, 'fa')
  );
}
